<template>
  <MarketingPageLayout>
    <h1 class="text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-3">Help articles</h1>
    <p class="text-lg text-ink-4 mb-12">
      Step-by-step guides for setup and daily use. Each article is also indexed inside the app.
    </p>

    <p v-if="!articles.length" class="text-ink-4 italic">Help articles will appear here.</p>

    <ul v-else class="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <li
        v-for="article in articles"
        :key="article.slug"
        class="border border-line rounded-xl p-5 hover:border-accent-line transition-all"
      >
        <router-link
          :to="`/help/${article.slug}`"
          class="block"
        >
          <h2 class="text-lg font-semibold text-ink mb-1 hover:text-accent">
            {{ article.title }}
          </h2>
          <p
            v-if="article.description"
            class="text-sm text-ink-2 leading-relaxed"
          >{{ article.description }}</p>
        </router-link>
      </li>
    </ul>
  </MarketingPageLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getAllContent } from '@/composables/useContent'
import { useSeo } from '@/composables/useSeo'
import MarketingPageLayout from '@/components/marketing/MarketingPageLayout.vue'
import { SITE_URL, WEBSITE_ID, SOFTWARE_ID } from '@/lib/seoEntities'

const articles = computed(() => getAllContent('help'))

useSeo({
  title: 'Help & how-to articles',
  description: 'Step-by-step guides for using NerdCRM — setup, call recording, imports, reports, and more.',
  path: '/help',
  jsonLd: {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'NerdCRM help and how-to articles',
    url: `${SITE_URL}/help`,
    inLanguage: 'en',
    isPartOf: { '@id': WEBSITE_ID },
    about: { '@id': SOFTWARE_ID },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: articles.value.map((a, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: a.title,
        url: `${SITE_URL}/help/${a.slug}`,
      })),
    },
  },
})
</script>
